export function FibiLoading({ text = "FIBI sedang memuat data dari router...", size = 24, className = "" }) {
  const px = `${size * 4}px`;
  return (
    <div className={`flex flex-col items-center justify-center py-8 sticky left-0 w-[calc(100vw-4rem)] max-w-full sm:w-auto ${className}`} data-testid="fibi-loading">
      <div className="relative" style={{ width: px, height: px }}>
        <div className="absolute inset-0 rounded-full border-4 border-[#F04E23]/20 border-t-[#F04E23] animate-spin" />
        <img src="/fibi.webp" alt="FIBI" className="absolute inset-2 rounded-full object-cover" style={{ width: `calc(${px} - 16px)`, height: `calc(${px} - 16px)` }} />
      </div>
      <p className="mt-3 text-sm font-medium text-muted-foreground animate-pulse">{text}</p>
    </div>
  );
}
